import { Type } from 'class-transformer';
import {ObjectiveProtocol} from 'lionheartland';
import {Constraint} from "../../dexie/db";

export class SORespConstraint implements ObjectiveProtocol {

  entityType: string = 'constraint';
  uid: string;
  name: string;
  identifier: string;
  description: string = "";

    toConstraint(): Constraint {
        return {
            uid: this.uid,
            name: this.name,
            identifier: this.identifier,
            description: this.description,
            appliedConstraintsUid: null,
}

        };
}